import React from 'react'
import PropTypes from 'prop-types'
import CalendarGif from '../../Assets/images/Calendar.gif';



class DatePickerwithIcon extends React.Component {
    static propTypes = {
      onClick: PropTypes.func,
       value: PropTypes.string,
       onChange: PropTypes.func,
       width: PropTypes.width !== undefined ? PropTypes.width : "100%"
    }
    render () {
      return (
          <div className="date_picker_box" >
            <input type="text" value= {this.props.value} onChange={this.props.onChange} style={{width: this.props.width}} />
            <img src={CalendarGif} alt="Trane Logo"  className="link_cursor"    onClick={this.props.onClick}/> 
        </div>
      )
    }
  }

export default DatePickerwithIcon;
